import { ModuleWithProviders, NgModule } from '@angular/core';
import { FACEBOOK_CONFIG } from './facebook.config';
import { FacebookConfig } from './facebook.interface';
import { Facebook } from './facebook.service';

@NgModule({
  providers: [Facebook],
})
export class FacebookModule {
  static initialize(config: FacebookConfig): ModuleWithProviders {
    return {
      ngModule: FacebookModule,
      providers: [Facebook, { provide: FACEBOOK_CONFIG, useValue: config }],
    };
  }
}
